import { plans } from 'src/app/queries/queries'

const fetchSubscriptionTypes = (filter, codePayload, success, error) => {
  return {
    type: 'API:SUBSCRIPTION_TYPES:FETCH',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: plans.QUERY_SUBSCRIPTION_TYPES,
      variables: {
        filter,
        // NOTICE 传入时只能传一个有效值
        promo_code: codePayload && codePayload.promo_code,
        sales_code: codePayload && codePayload.sales_code,
        referral_code: codePayload && codePayload.referral_code
      }
    }
  }
}

const fetchBeachVacationTypes = (success, error) => ({
  type: 'API:BEACH:VACATION:TYPES',
  API: true,
  method: 'POST',
  url: '/api/query',
  success,
  error,
  data: {
    query: plans.QUERY_SUBSCRIPTION_TYPES,
    variables: {
      filter: 'signupable',
      promo_code: '',
      occasion_filter: 'beach_vacation'
    }
  }
})

const setSelectedCard = id => ({
  type: 'SET:SELECTED:CARD',
  id
})

const getExtendableSubscriptionTypes = (success, error) => ({
  type: 'GET:EXTENDABLE:SUBSCRIPTION:TYPES',
  API: true,
  method: 'POST',
  success,
  error,
  url: '/api/query',
  data: { query: plans.QUERY_EXTENDABLE_SUBSCRIPTION_TYPES }
})

const fetchPreviewSubscriptionType = (
  id,
  { promo_code, sales_code, referral_code },
  success,
  error
) => ({
  type: 'API:FETCH:PREIVEW:SUBSCRIPTION:TYPE',
  API: true,
  method: 'POST',
  url: '/api/query',
  success,
  error,
  data: {
    query: plans.QUERY_SUBSCRIPTION_TYPE_PREVIEW,
    variables: { id, promo_code, sales_code, referral_code }
  }
})

export default {
  fetchSubscriptionTypes,
  fetchBeachVacationTypes,
  setSelectedCard,
  getExtendableSubscriptionTypes,
  fetchPreviewSubscriptionType
}
